import { render } from "./CRMWhatsappMessageNoteDialog.vue?vue&type=template&id=3528f6a6"
import script from "./CRMWhatsappMessageNoteDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappMessageNoteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__